"use strict";

import React from 'react';
import {FluxMixin, StoreWatchMixin} from 'fluxxor'
import RatesGuide from 'ofs/react/components/rates-guide';
import BookingQuote from './BookingQuote';
import {gettext} from 'ofs/i18n';

const messages = {
  BOOK_YOUR_STAY: gettext("Book your stay"),
  LOADING: gettext("Loading"),
  FROM_THE_EVENING: gettext('From the evening of'),
  TO_THE_MORNING: gettext("To the morning of"),
  BOOK_NOW: gettext("Book now"),
};

const QuoteModal = React.createClass({
  mixins: [
    FluxMixin(React),
    StoreWatchMixin("BookingQuoteStore", "UnitStore")
  ],

  getStateFromFlux() {
    const flux = this.getFlux();

    return {
      quote: flux.store('BookingQuoteStore').state,
      unit: flux.store('UnitStore').state
    };
  },

  renderForm() {
    const quoteStore = this.getFlux().store('BookingQuoteStore');
    const quoteData = this.state.quote.get('quoteData');

    return (
      <form className="booking-form" method="post" action={this.state.quote.get('bookUrl')}>
        <input type="hidden" name="start_date" value={quoteStore.getISO8601StartDate()} />
        <input type="hidden" name="end_date" value={quoteStore.getISO8601EndDate()} />

        <div className="booking-dates">
          <p className="label">{messages.FROM_THE_EVENING}</p>
          <p className="value">{quoteStore.getFormattedStartDate()}</p>

          <p className="label">{messages.TO_THE_MORNING}</p>
          <p className="value">{quoteStore.getFormattedEndDate()}</p>
        </div>
        {this.state.quote.get('range') && quoteData ? <BookingQuote data={quoteData} /> : null}

         <button className="button" disabled={!this.state.quote.get('bookable')}>{messages.BOOK_NOW}</button>
      </form>
    );
  },

  render() {
    const loading = this.state.quote.get('loading');

    return (
      <div>
        <h2>{messages.BOOK_YOUR_STAY}</h2>
        {loading ? <p>{messages.LOADING}</p> : this.renderForm()}
      </div>
    );
  }
});

export default QuoteModal;



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/apps/legacy/property/default/views/QuoteModal.jsx
 **/